"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Communications } from "@/src/gql/graphql";

/**
 * Communications Timeline Display Tab Component
 */
export function CommunicationsTimelineDisplay({ item }: TabContentProps<Communications>) {
  const communicationWithExtended = item as unknown as any;
  
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-4">
          {/* Created Event */}
          <div className="flex gap-4">
            <div className="flex flex-col items-center">
              <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
              <div className="w-0.5 h-12 bg-gray-200 dark:bg-gray-700 mt-2"></div>
            </div>
            <div className="pb-4">
              <p className="font-medium text-gray-900 dark:text-gray-100">Communication Created</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {communicationWithExtended.created_at
                  ? new Date(communicationWithExtended.created_at).toLocaleString()
                  : "Unknown date"}
              </p>
            </div>
          </div>

          {/* Occurred Event */}
          {communicationWithExtended.occurred_at && (
            <div className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <div className="w-0.5 h-12 bg-gray-200 dark:bg-gray-700 mt-2"></div>
              </div>
              <div className="pb-4">
                <p className="font-medium text-gray-900 dark:text-gray-100">Communication Occurred</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {new Date(communicationWithExtended.occurred_at).toLocaleString()}
                </p>
              </div>
            </div>
          )}

          {/* Last Updated Event */}
          {communicationWithExtended.updated_at && (
            <div className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
              </div>
              <div>
                <p className="font-medium text-gray-900 dark:text-gray-100">Last Updated</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {new Date(communicationWithExtended.updated_at).toLocaleString()}
                </p>
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
